// Onde a pessoa vai treinar. Step NOVO (pergunta "local" do
// Objetivo.dc.html).
//
// Não é só um rótulo: é o que decide o equipamento disponível. O gerador de
// plano espera `equipamentos_disponiveis` (lista de ids do catálogo dele) e,
// sem esta pergunta, todo mundo saía com o preset de academia completa — e
// quem treina em casa recebia plano com leg press.
//
// O preset é PONTO DE PARTIDA, não sentença: quem quiser afinar o
// equipamento item por item continua tendo o gerador de plano na aba Treino.
// O mapeamento id-por-id vive em `mapaGeracao.js`, junto com o resto da
// tradução onboarding → payload.

import React, { useEffect, useState } from "react";

import { Opcoes } from "../widgets/Widgets.jsx";

const OPCOES = [
  { value: "academia", label: "Academia completa" },
  { value: "casa", label: "Em casa, com halteres" },
  { value: "peso_corpo", label: "Só o peso do corpo" },
];

const StepLocalTreino = ({ setCanProceed, setStepData }) => {
  const [local, setLocal] = useState("");

  useEffect(() => {
    const valido = Boolean(local);
    setCanProceed(valido);
    setStepData(valido ? { TRAINING_PLACE: local } : null);
  }, [local, setCanProceed, setStepData]);

  return (
    <Opcoes
      opcoes={OPCOES}
      valor={local}
      onSelecionar={setLocal}
      numeradas={false}
      nome="Local de treino"
    />
  );
};

export default StepLocalTreino;
